import { Link } from 'react-router-dom';
import { Chat } from '../components/Chat';

export function AiCto() {
  return (
    <main className="flex flex-col h-screen">
      {/* Header */}
      <header className="flex items-center justify-between border-b border-slate-800 px-6 py-4 shrink-0">
        <div>
          <p className="text-xs uppercase tracking-widest text-sky-400">Workspace</p>
          <h1 className="mt-0.5 text-lg font-semibold">AI-CTO Chat</h1>
        </div>
        <Link to="/dashboard" className="text-sm text-slate-400 hover:text-slate-200">
          ← Dashboard
        </Link>
      </header>

      {/* Chat area — fills the remaining viewport height */}
      <div className="flex-1 overflow-hidden">
        <Chat />
      </div>
    </main>
  );
}
